import { Checkbox as MuiCheckbox, CheckboxProps } from '@mui/material';

export const Checkbox = ({ ...otherProps }: CheckboxProps) => {
  return <MuiCheckbox {...otherProps} />;
};
